import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteSubjectMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = [{
        instituteMasterId: '',
        subject: []
    }]

    const [GradeData, setGradeData] = useState([]);
    const [InstituteSubjectData, setInstituteSubjectData] = useState([]);
    const [adminSubList, setAdminSubList] = useState([]);
    const [subjectName, setGradeName] = useState('');
    const [adminSubject, setAdminSubject] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [editId, setEditId] = useState(null);
    const [error, setError] = useState(null);
    const [instituteError, setInstituteError] = useState([]);
    const [isCheck, setIsCheck] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [subjectSort, setSubjectSort] = useState(null);
    const [dateSort, setDateSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["subjectName", "createdAt"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSubjectList();
        getSubject();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getSubjectList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setSubjects(await searchArray("I", `/get-institute-subjects?instituteMasterId=${instituteMasterId}`, searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subjects, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(subjects.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subjects.length) {
            endIndex = subjects.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subjects.slice(startIndex, endIndex));
    }, [subjects, currPage, itemsPerPage]);

    const getSubject = () => {
        const apiUrl = `/get-subject-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setAdminSubject(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getSubjectList = async () => {
        try {
            const apiUrl = `/get-institute-subjects?instituteMasterId=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setSubjects(response.data.result);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        if (GradeData.length !== 0) {
            setError('')
        }
    }, [GradeData])

    const isValid = () => {
        let isValid = true;

        if (GradeData.length > 0) {
            if (InstituteSubjectData.some(sub => sub.subjectName.length === 0)) {
                setError(null);
                isValid = false;
            }
        } else if (GradeData.length === 0) {
            setInstituteError(null);
            isValid = false;
        }

        return isValid;
    };

    const addSubject = async () => {
        // if (GradeData.length !== 0) {
        if (isValid()) {
            try {
                const apiUrl = `/add-institute-subjects`;
                setLoading(true);
                const response = await authorizedAxiosInstitute.post(apiUrl, {
                    instituteMasterId: instituteMasterId,
                    subject: GradeData.concat(InstituteSubjectData)
                });
                await getSubjectList();
                // setSaveId(response.data.result[0].id);
                setCurrPage(1);
                setGradeData([]);
                setInstituteSubjectData([])

                setSubjectSort(null);
                setDateSort(null);
                setSearchValue(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            if (InstituteSubjectData.length > 0) {
                if (InstituteSubjectData.some(sub => sub.subjectName.length === 0)) {
                    setError(null);
                    setInstituteError("Subject is required")
                }
            } else if (GradeData.length === 0) {
                setInstituteError(null);
                setError("Subject is required");
            }
        }
    }

    const deleteSubject = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `delete-institute-subjects?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, subjects.length);
                await getSubjectList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateGrade = () => {
        setLoading(true);
        const apiUrl = `/edit-grade-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, {
            subjectName,
        })
            .then(response => {
                setSubjects((prevGrades) => [...prevGrades].map((grade) => grade.id == editId ? response.data.result : grade));
                setEditId(null);
                setGradeName('')
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleAddGrade = (data) => {
        setGradeData((preData) => {
            if (GradeData?.some(i => i.subjectMasterId == data.subjectMasterId)) {
                return GradeData.filter(i => i.subjectMasterId != data.subjectMasterId)
            }
            else {
                return [...preData, data]
            }
        })
    }

    const handleAddGradeSelect = (data) => {
        setGradeData(data.map(i => { return { subjectMasterId: i.value, subjectName: i.label } }))
    }

    const handleAddLesson = () => {
        setInstituteSubjectData((prevData) => (
            [...prevData, {
                subjectMasterId: null,
                subjectName: ""
            }]
        ));
        setError(null);
    };

    useEffect(() => {
        if (isCheck) {
            isValid();
        }
    }, [InstituteSubjectData, isCheck])

    const handleInputChange = (e, index) => {
        setInstituteSubjectData(prevDataArray => {
            return prevDataArray.map((item, i) => (i === index ? { ...item, subjectName: e.target.value } : item));
        });

        setIsCheck(true);
    }

    const handleRemoveLesson = (index) => {
        setInstituteSubjectData(InstituteSubjectData.filter((_, i) => i !== index))
    };

    useEffect(() => {
        setAdminSubList(adminSubject.filter(i =>
            !subjects.some(j => i.id == j.subjectMasterId)
        ))
    }, [adminSubject, subjects])

    const handleInputReset = () => {
        setEditId('');
        setGradeData(initialFormState);
        setInstituteSubjectData([])
    }

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setDateSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (dateSort == true || dateSort == false) {
            setSubjectSort(null);
        }
    }, [dateSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Subject Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-lines"></i> Subject Master</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject Name</label>
                                                    <Select
                                                        value={GradeData?.map((i) => {
                                                            if (i.subjectMasterId && i.subjectName) {
                                                                return {
                                                                    value: i.subjectMasterId,
                                                                    label: i.subjectName
                                                                }
                                                            }
                                                        })}
                                                        name="state"
                                                        isMulti
                                                        options={adminSubList?.map((i) => {
                                                            return {
                                                                value: i.id,
                                                                label: i.subjectName
                                                            }
                                                        })}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={(data) => handleAddGradeSelect(data)}
                                                    />
                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>

                                                {InstituteSubjectData?.map((grade, index) => (
                                                    <>
                                                        <div className="col-md-5">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Subject Name :</label>
                                                            <input type="text" className="form-control" id={`lessonName${index}`} name='subjectName' onChange={(e) => handleInputChange(e, index)} value={grade.subjectName} />
                                                            {instituteError && grade.subjectName == "" && <p style={{ color: 'red' }}>{instituteError}</p>}
                                                        </div>
                                                        <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                            <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveLesson(index)} ><i class="material-icons" style={{ fontSize: '20px' }} >delete</i></button>
                                                        </div>
                                                    </>
                                                ))}

                                                <div className="col-md-12 mt-4 mb-1">
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary" type="button" style={{ width: '233px' }} onClick={handleAddLesson}>+ Add Another Subject Name</button>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" style={{ marginRight: "20px" }} type="button" onClick={addSubject}>Save</button>
                                                        }
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                        {/* {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateGrade} disabled={!editId}>Update</button>)
                                                        } */}
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSubjects} setCurrPage={setCurrPage} sortingPath={"subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Date
                                                                            <SortIcon sortState={dateSort} setSortState={setDateSort} setData={setSubjects} setCurrPage={setCurrPage} sortingPath={"createdAt"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((grade, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{grade.subjectName}</td>
                                                                                        <td>{grade.createdAt.split(",")[0]}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteSubject(grade.id)} ><i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Subject Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subjects.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteSubjectMaster;